import { Chip, type ChipOwnProps, Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';

import { DATE_FORMAT } from '@/constants/date.constants';
import { PRODUCTS } from '@/constants/products.constants';
import type { TableColumn } from '@/features/OrganizationTable/OrganizationsTable.types';
import {
  getProductSubTypeDisplay,
  type ProductDTO,
  productIsExpired,
  productIsExpiringSoon
} from '@/pages/Organizations';

const getEndDateColor = (product: ProductDTO): ChipOwnProps['color'] => {
  let color: ChipOwnProps['color'] = 'success';
  if (productIsExpired(product)) {
    color = 'error';
  }
  if (productIsExpiringSoon(product)) {
    color = 'warning';
  }
  return color;
};

const getSubscription = (product: ProductDTO) => {
  let subscription = `${product.subscription_limit} ${
    product.subscription_unit || ''
  }`;
  if (!product.subscription_limit) {
    subscription = '';
  }
  if (product.product_type === PRODUCTS.RET) {
    subscription = `${parseInt(product.retention || '0', 10)}/${parseInt(
      product.archive_retention || '0',
      10
    )} Online/Offline Days`;
  }
  return subscription;
};

export const getProductCell = (column: TableColumn, product: ProductDTO) => {
  switch (column.id) {
    case 'product_type':
      return (
        <Stack direction="row" sx={{ alignItems: 'center' }} spacing={1}>
          <strong>{product.product_type}</strong>
          {product.sub_type && (
            <Typography
              variant="body1"
              sx={{ fontStyle: 'italic' }}
              color="textPrimary_a50"
            >
              ({getProductSubTypeDisplay(product.sub_type)})
            </Typography>
          )}
        </Stack>
      );
    case 'subscription':
      return getSubscription(product);
    case 'start_date':
      return dayjs(product.start_date).format(DATE_FORMAT);
    case 'end_date':
      return (
        <Chip
          variant="outlined"
          label={dayjs(product.end_date).format(DATE_FORMAT)}
          color={getEndDateColor(product)}
        />
      );
    default:
      return product[column.id as keyof ProductDTO];
  }
};
export default getProductCell;
